import module from 'finanzas/module.js'
import template from './template.html'
import * as moment from 'moment'

export class FinancesServiciosagregadosExportarComponent {
  fechaInicial
  fechaFinal
  data
  onClose
  opciones = {
    archivo_nombre: '',
  }

  constructor ($export) {
    this.$export = $export
  }

  $onInit () {
    let fechaInicial = moment(this.fechaInicial).format('YYYY-MM-DD')
    let fechaFinal = moment(this.fechaFinal).format('YYYY-MM-DD')
    this.opciones.archivo_nombre = `Servicios agregados entre ${fechaInicial} y ${fechaFinal}`
  }

  cerrar () {
    this.onClose()
  }

  exportar () {
    let data = this.data.map((item) => [
      item.ID_Empresa,
      item.ID_Empleado,
      item.Empleado,
      item.Empresa,
      item.Folio,
      item.Codigo_Movimiento,
      item.Concepto,
      item.Tipo_Moneda === '1' ? 'MXN' : 'USD',
      moment(item.Fecha_Movimiento).format('DD//MM/YYYY'),
      item.Status ? 'Activo' : 'Inactivo',
      item.Captura_Usuario_Nombre,
      moment(item.Captura_Fecha).format('DD//MM/YYYY'),
      item.Naturaleza === 'C' ? item.Importe : '',
      item.Naturaleza === 'A' ? item.Importe : '',
      item.Notas,
    ])

    let page = {
      name: 'Resumen',
      details: [
        {label: `Servicios agregados: ${data.length}`, cell: 'D1'},
      ],
      columns: [
        {label: 'Empr.', format: {align: 'center', width: 4}},
        {label: 'Empl.', format: {align: 'center', width: 7}},
        {label: 'Nombre', format: {width: 30}},
        {label: 'Empresa', format: {width: 30}},
        {label: 'Folio', format: {width: 10}},
        {label: 'Cod.', format: {width: 5}},
        {label: 'Concepto', format: {width: 25}},
        {label: 'Moneda', format: {width: 10, align: 'center'}},
        {label: 'Fecha', format: {type: 'date', width: 10}},
        {label: 'Status', format: {width: 10, align: 'center'}},
        {label: 'Capt. Usuario', format: {width: 20}},
        {label: 'Capt. Fecha', format: {type: 'date', width: 10}},
        {label: 'Cargo', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
        {label: 'Abono', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
        {label: 'Notas', format: {width: 80}},
      ],
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data,
    }

    this.$export.excel(this.opciones.archivo_nombre, [page])
    this.cerrar()
  }
}

module.component('financesServiciosagregadosExportar', {
  controller: FinancesServiciosagregadosExportarComponent,
  template,
  bindings: {
    fechaInicial: '<',
    fechaFinal: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/serviciosagregados/exportar/component.js